
function checkSpace(el, { value, modifiers }, vnode) {
    try {
      let len  = el.children.length-1;
      //获取多文本输入框元素
      el = el.children[0];
      if (!el.value) {
        return false;
      }
      el.value = el.value.replace(/\s+/g, "");
      el.dispatchEvent(new Event(modifiers.lazy ? 'change' : 'input'))
    } catch (e) {
    }
  
  }
  
  export default {
    update(el, { value, modifiers }, vnode) {
      checkSpace(el, { value, modifiers }, vnode)
    }
  }
  